import createCommonEntitySettings from 'client/pages/createCommonEntitySettings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import { WebsiteLoginSettings } from 'src/editor/shared/settings/website-login-settings'
import { WebsiteLoginInterface } from 'src/shared/types/entities/website-login-interface'

const createSettingsForWebsiteLogin = (entity: EntityInterface) => {
  switch (entity.type) {
    case EntityTypeEnum.WebsiteLogin:
      return <WebsiteLoginSettings entity={entity as WebsiteLoginInterface} />

    default:
      return createCommonEntitySettings(entity)
  }
}

export default createSettingsForWebsiteLogin
